import React from 'react';
import { setFallbackImage } from '../../../utils/imageHelper';
import { BREEDER_SELLER_DEFAULT_IMAGE } from '../../../utils/constants';
import PhoneNumber from '../../search/admin-dashboard-tables/assets/PhoneNumber';
import TextOrCall from '../../buttons/TextOrCall';
import { SellerContactFormSellerContactInfo } from '../../../structures/models/seller';

interface Props {
  sellerName?: string,
  profilePhotoUrl?: string,
  contact: SellerContactFormSellerContactInfo,
}

const SellerDetailsContact: React.FC<Props> = ({
  sellerName,
  profilePhotoUrl,
  contact,
}) => {
  const {
    name,
    primaryCanBeCalled,
    primaryCanBeTexted,
    phone,
    phone_extn,
    alternateCanBeCalled,
    alternateCanBeTexted,
    alternate_phone,
    alternate_phone_extn,
    best_time_to_call,
    website,
    hours,
  } = contact;
  const canBeCalled = primaryCanBeCalled || alternateCanBeCalled;
  const canBeTexted = primaryCanBeTexted || alternateCanBeTexted;

  return (
    <div className="seller-details-contact border-top border-bottom">
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div className="d-flex flex-row align-items-center">
          <img
            className="rounded-circle round-30 lazy"
            src={profilePhotoUrl || BREEDER_SELLER_DEFAULT_IMAGE}
            onError={(e) => {
              setFallbackImage(e, BREEDER_SELLER_DEFAULT_IMAGE);
            }}
            alt={sellerName || ''}
          />
          <p className="ml-1 mb-0 basic-txt text-secondary">
            <small>
              {`Contact: ${name}`}
            </small>
          </p>
        </div>
        <a className="text-decoration-none" role="button" data-toggle="modal" data-target="#ShareSeller">
          <span className="icon-share-network h3" />
        </a>
      </div>
      {(canBeCalled || canBeTexted) && (
        <>
          <div className="d-flex mt-3 ml-2 text-secondary justify-content-between">
            <div className="mr-3 seller-detail-text">
              <i className="fa fa-phone-alt fa-circle mr-2" />
              {' '}
              <PhoneNumber
                phone={phone}
                phone_extn={phone_extn}
                linkClassName="text-decoration-none seller-contact color-txt"
                textClassName="text-decoration-none seller-contact color-txt d-inline-block mb-0"
                useSmsLink={!primaryCanBeCalled && primaryCanBeTexted}
              />
            </div>
            <TextOrCall
              canBeCalled={primaryCanBeCalled}
              canBeTexted={primaryCanBeTexted}
              phone={phone}
              phoneExtn={phone_extn}
            />
          </div>
          {alternate_phone && (
            <div className="d-flex mt-2 ml-2 text-secondary justify-content-between">
              <div className="mr-3 seller-detail-text">
                <i className="fa fa-phone-alt fa-circle mr-2" />
                {' '}
                <PhoneNumber
                  phone={alternate_phone}
                  phone_extn={alternate_phone_extn}
                  linkClassName="text-decoration-none seller-contact color-txt"
                  textClassName="text-decoration-none seller-contact color-txt d-inline-block mb-0"
                  useSmsLink={!alternateCanBeCalled && alternateCanBeTexted}
                />
              </div>
              <TextOrCall
                canBeCalled={alternateCanBeCalled}
                canBeTexted={alternateCanBeTexted}
                phone={alternate_phone}
                phoneExtn={alternate_phone_extn}
              />
            </div>
          )}
          {best_time_to_call && (
            <div data-fsid="best-time-to-call" className="d-flex justify-content-between align-items-center mt-3 ml-2">
              <p>
                <i className="icon-call-time" />
                {' '}
                <span className="text-decoration-none seller-detail-text blue-txt">
                  {`Best time to call: ${best_time_to_call}`}
                </span>
              </p>
            </div>
          )}
          {website && (
            <a
              className="badge badge-pill border border-secondary text-secondary mb-3 text-uppercase"
              href={website}
              target="_blank"
              rel="noreferrer"
            >
              <small>
                Seller Website
                {' '}
                <i className="fa fa-external-link-alt" />
              </small>
            </a>
          )}
        </>
      )}
    </div>
  );
};

export default SellerDetailsContact;
